import { ScreenTrigger, ScreenType, Step } from '@frontend/wizard/types';

import { useScreen } from '../useScreen';

interface ViewProps {
    pinStep?: Step;
    scanStep?: Step;
    itsmeStep?: Step;
    onContinue: (nextStep?: Step | undefined) => void;
    onBack: (type: ScreenType) => void;
}

const usePickUpMethod = (): ViewProps => {
    const { store, onBack, onSubmit: onContinue } = useScreen();

    return {
        pinStep: store?.steps.find(
            (step) => step.screen === ScreenType.PICK_UP_METHOD && step.trigger === ScreenTrigger.SUBMIT && step.next_screen === ScreenType.PICK_UP_PIN_CODE
        ),
        scanStep: store?.steps.find(
            (step) => step.screen === ScreenType.PICK_UP_METHOD && step.trigger === ScreenTrigger.SUBMIT && step.next_screen === ScreenType.PICK_UP_SCAN_QR_CODE
        ),
        itsmeStep: store?.steps.find(
            (step) =>
                step.screen === ScreenType.PICK_UP_METHOD && step.trigger === ScreenTrigger.SUBMIT && step.next_screen === ScreenType.ITSME_QR_AUTHENTICATION
        ),
        onContinue,
        onBack
    };
};

export default usePickUpMethod;
